import React, { useState } from 'react';
import { ShieldAlert, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import ChangePasswordDialog from './ChangePasswordDialog';

// Amber banner shown when the logged-in password failed the strength policy
// (e.g. the legacy default admin123). Prompts rotation before go-live.
const WeakPasswordBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [open, setOpen] = useState(false);

  if (!user?.weak_password || user.must_change_password || dismissed) return null;

  return (
    <>
      <div className="flex items-center gap-3 px-4 py-2 bg-amber-100 dark:bg-amber-950/40 border-b border-amber-300 dark:border-amber-800 text-amber-900 dark:text-amber-200" data-testid="weak-password-banner">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        <p className="text-sm flex-1">
          <span className="font-semibold">Your password is weak or still the default.</span> Set a strong password before using the platform with real data.
        </p>
        <Button size="sm" className="h-7 bg-amber-600 hover:bg-amber-700 text-white" onClick={() => setOpen(true)} data-testid="weak-password-change-btn">
          Change password now
        </Button>
        <button className="p-1 rounded hover:bg-amber-200 dark:hover:bg-amber-900" onClick={() => setDismissed(true)} title="Dismiss for this session" data-testid="weak-password-dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
      <ChangePasswordDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default WeakPasswordBanner;
